import React from 'react';
import { usePublicSettings } from '../../hooks/useApi';

// NUY coin mark — same violet → blue gradient as the Nuyed logotype.
// Uses the admin-configured image (Settings → Branding → NUY coin icon) or this default SVG.
export function NuyCoinSvg({ className = 'w-5 h-5', id = 'nuy' }) {
  return (
    <svg viewBox="0 0 64 64" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="NUY">
      <defs>
        <linearGradient id={`${id}-rim`} x1="8" y1="6" x2="56" y2="58" gradientUnits="userSpaceOnUse">
          <stop stopColor="#6A2BF2" /><stop offset=".55" stopColor="#3C5CF3" /><stop offset="1" stopColor="#2077F0" />
        </linearGradient>
        <linearGradient id={`${id}-n`} x1="20" y1="18" x2="46" y2="46" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7A3BFF" /><stop offset="1" stopColor="#2A7BFF" />
        </linearGradient>
        <linearGradient id={`${id}-shine`} x1="14" y1="10" x2="40" y2="34" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" stopOpacity=".28" /><stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
      </defs>
      <circle cx="32" cy="32" r="30" fill={`url(#${id}-rim)`} />
      <circle cx="32" cy="32" r="25" fill="#0B1020" />
      <circle cx="32" cy="32" r="25" stroke="#ffffff" strokeOpacity=".08" />
      <circle cx="32" cy="32" r="30" fill={`url(#${id}-shine)`} />
      <path d="M22.5 43.5V20.5L41.5 43.5V20.5" stroke={`url(#${id}-n)`} strokeWidth="6.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22.5 43.5V20.5L41.5 43.5V20.5" stroke="#fff" strokeOpacity=".16" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function NuyIcon({ className = 'w-5 h-5', rounded = true }) {
  const { data: site } = usePublicSettings();
  const url = site?.coin_icon_url && /^(https?:\/\/|\/)[^\s]+$/.test(String(site.coin_icon_url).trim()) ? String(site.coin_icon_url).trim() : null;
  if (url) return <img src={url} alt="NUY" className={`${className} object-contain ${rounded ? 'rounded-full' : ''}`} data-testid="nuy-coin-icon" />;
  return <NuyCoinSvg className={className} />;
}
